import React from 'react';
import { MfeReactComponent } from '@carvana/microfrontend-react';
import isCarvanaMobileAppUserAgent from '../../../utils/isCarvanaMobileApp';

export default function Footer() {
  if (isCarvanaMobileAppUserAgent()) {
    return null;
  }

  return (
    <>
      <MfeReactComponent
        component="default"
        module="FooterModule"
        environment={process.env.NODE_ENV}
        withoutProvider
      />
    </>
  );
}
